export default __webpack_public_path__ + "static/media/s6.21dab7de.png";